import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const secciones = [
  {
    label: 'Antecedentes Normativos',
    to: '/ControlInterno/AntecedentesNormativos',
  },
  {
    label: 'Carpetas Digitales y Evidencias',
    to: '/ControlInterno/CarpetasDigitales',
  },
  {
    label: 'Componentes del Control Interno',
    to: '/ControlInterno/ComponentesCI',
  },
  {
    label: 'Estructura del COCODI',
    to: '/ControlInterno/EstructuraCOCODI',
  },
];

const MicrositioSCI = () => {

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <HeaderSCI title="MICROSITIO - SISTEMA DE CONTROL INTERNO" />

      {/* ── NAVIGATION BUTTONS ── */}
      <div className="container ci-nav" style={{ maxWidth: '1000px' }}>
        <div className="row justify-content-center">
          {secciones.map((sec, idx) => (
            <div key={idx} className="col-lg-5 col-md-6 col-12 mb-2">
              <Link to={sec.to} className="ci-nav__btn ci-nav__btn--doc">
                <div className="ci-nav__icon">
                  <i className="fa-regular fa-address-card"></i>
                </div>
                <span className="ci-nav__label ci-nav__label--doc">{sec.label}</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MicrositioSCI;
